<template>
  <div>
    <!-- header -->
    <v-container
        fluid
        class="py-0"
        style="box-shadow: 0px 2px 10px rgba(9, 14, 24, 0.1); background-color: white; z-index: 999; position:fixed;">
      <v-row class="flex-column">
        <v-col
            class="py-2 hidden-sm-and-down"
            style="background-color: #231F20">
          <v-row class="justify-center white--text text-body-2 font-weight-medium">
            <div class="text-uppercase pr-6">
              <v-icon color="accent" class="mr-2">mdi-chart-box-outline</v-icon>
              <span class="accent--text" style="font-weight: 600">{{ $t('top_nav1') }}</span>
            </div>
            <div>
              <span>{{ $t('top_nav2') }} -</span>
              <span class="px-4"> | </span>
              <span>{{ $t('top_nav3') }} 146</span>
              <span class="px-4"> | </span>
              <span>{{ $t('top_nav4') }} 20</span>
            </div>

            <div style="position: absolute; right: 20px">
              <v-menu
                  open-on-hover
                  bottom
                  offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon size="20" left class="mb-1" color="white">mdi-flag-outline</v-icon>
                    <span>{{ activeLang.toUpperCase() }}</span>
                  </div>
                </template>

                <v-list>
                  <v-list-item-group>
                    <v-list-item
                        v-for="(item, index) in langs"
                        :key="index">
                      <v-list-item-title @click="changeLanguage(item.alias)">{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </v-col>

        <v-col class="py-0" style="height: 80px">
          <v-container v-if="currentRoute === '/' || $route.fullPath === '/en' || $route.fullPath === '/en/'" class="py-0">
            <v-row class="hidden-sm-and-down">
              <v-col cols="2" class="py-0">
                <div
                    class="d-flex align-center justify-start"
                    style="height: 100%"
                >
                  <router-link :to="`${$route.params.lang === 'en' ? '/en' : '/'}`">
                    <img src="@/assets/edu-logo.svg"/>
                  </router-link>
                </div>
              </v-col>
              <v-col cols="7" class="py-0">
                <v-tabs height="80" color="accent" :ripple="false" centered>
                  <v-tab
                      :ripple="false"
                      v-for="(link, index) in navLinks"
                      :key="index"
                      @click="selectedTab(index)"
                  >
                    {{ $t(link) }}
                  </v-tab>
                </v-tabs>
              </v-col>
              <v-col cols="3" class="py-0">
                <div
                    class="d-flex align-center justify-end"
                    style="height: 100%"
                >
                  <v-btn
                      class="accent text-none elevation-0 white--text px-6"
                      style="font-weight: 600"
                      height="40"
                      :to="`${$route.params.lang === 'en' ? '/en' : ''}/moj-eduid`"
                  >{{ $t('home_page_button1') }}
                    <v-icon class="ml-3">mdi-clipboard-account</v-icon>
                  </v-btn
                  >
                </div>
              </v-col>
            </v-row>

            <v-row class="hidden-md-and-up">
              <v-col class="py-4 d-flex align-center justify-start">
                <router-link :to="`${$route.params.lang === 'en' ? '/en' : '/'}`">
                  <img src="@/assets/edu-logo.svg"/>
                </router-link>
              </v-col>
              <v-col v-if="!menu" class="py-0 d-flex justify-end">
                <v-icon @click="menu = true" color="secondary" size="28"
                >mdi-menu
                </v-icon
                >
              </v-col>
              <v-col
                  v-else
                  @click="menu = false"
                  class="py-0 d-flex justify-end"
              >
                <v-icon color="secondary" size="28">mdi-close</v-icon>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-else-if="currentRoute == '/koordinatori'">
            <v-row>
              <v-col class="py-0 d-flex align-center justify-start">
                <router-link to="/">
                  <img src="@/assets/edu-logo.svg"/>
                </router-link>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-else>
            <v-row>
              <v-col class="py-0 d-flex align-center justify-start">
                <router-link :to="`${$route.params.lang === 'en' ? '/en' : '/'}`">
                  <img src="@/assets/edu-logo.svg"/>
                </router-link>
              </v-col>
              <v-col class="py-0 d-flex align-center justify-end">
                <v-btn
                    class="accent text-none elevation-0 white--text px-6"
                    style="font-weight: 600"
                    height="40"
                    :to="`${$route.params.lang === 'en' ? '/en' : ''}/korisnik`"
                >{{  $t('login_button') }}
                  <v-icon class="ml-3">mdi-import</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-show="menu" class="dropdown hidden-md-and-up">
      <v-row>
        <v-col cols="12" class="py-0 d-flex align-center justify-end">
          <!-- <ul class="pa-0 text-uppercase text-body-2">
            <li><a href="">Osnovne informacije</a></li>
            <li class="middle-list-item"><a href="">Shema osoba</a></li>
            <li><a href="">Shema organizacije</a></li>
          </ul> -->
          <v-tabs color="accent" vertical class="pt-15 mb-6 mr-6">
            <v-tab
                :ripple="false"
                right
                v-for="(link, index) in navLinks"
                :key="index"
                @click="selectedTab(index)"
                class="mb-2">
              {{ $t(link) }}
            </v-tab>
          </v-tabs>
        </v-col>

        <v-col cols="12" class="pb-6 pt-0 pr-9 d-flex align-center justify-end">
          <v-btn dense outlined class="mr-5" :color="activeLang === 'hr' ? 'accent': ''"  @click="changeLanguage('hr')"><v-icon left>mdi-flag-outline</v-icon>HR</v-btn>
          <v-btn dense outlined :color="activeLang === 'en' ? 'accent': ''"  @click="changeLanguage('en')"><v-icon left>mdi-flag-outline</v-icon>EN</v-btn>
        </v-col>

        <v-col cols="12" class="py-0 d-flex align-center justify-end">
          <v-btn
              class="accent text-none elevation-0 white--text mr-6"
              style="font-weight: 600; padding: 0px 75px;"
              height="50"
              :to="`${$route.params.lang === 'en' ? '/en' : ''}/moj-eduid`"
              @click="menu = false">
            {{ $t('home_page_button1') }}
            <v-icon class="ml-3">mdi-clipboard-account</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <a href="https://sumit.sum.ba/" target="_blank ">
        <v-img
            class="dropdown-sumit"
            max-height="60"
            max-width="100"
            src="@/assets/sumit-grey.svg"
        ></v-img>
      </a>
    </v-container>
  </div>
</template>

<script>
import {serverBus} from "../../main";
import i18n from "@/plugins/i18n";

export default {
  data: () => ({
    menu: false,
    navLinks: ['menu_basic_information', 'menu_person_schema', 'menu_org_schema'],
    activeLang: '',
    langs: [
      {
        title: 'Hrvatski',
        alias: 'hr',
      },
      {
        title: 'Engleski',
        alias: 'en',
      }
    ],
  }),
  created() {
    this.activeLang = i18n.locale
    if(this.$route.params.lang === 'en' && this.activeLang === 'hr'){
      localStorage.setItem('setLanguage', 'en')
      location.reload();
    } else if(this.$route.fullPath === '/' && this.activeLang === 'en'){
      localStorage.setItem('setLanguage', 'hr')
      location.reload();
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    },
    currentLanguage(){
      return this.$route.params.lang
    }
  },
  methods: {
    selectedTab(index) {
      this.menu = false;
      serverBus.$emit("selected-tab", index);
    },
    changeLanguage(value) {
      localStorage.removeItem('setLanguage')
      localStorage.setItem('setLanguage', value)
      this.$router.push({name: 'LanguageHomePage', params: {lang: value === 'en' ? 'en' : ''}})
      location.reload();
    },
  }
};
</script>

<style>
@media only screen and (max-width: 960px) {
  .v-tabs-slider-wrapper {
    left: unset !important;
    right: 0 !important;
  }

  .v-tabs-bar__content {
    align-items: flex-end !important;
  }
}
</style>
